import "./main.css";
import "@velaro/velaro-shared/src/main.css";
import React from "react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { createRoot } from "react-dom/client";
import "react-dom"; //needs to be here since it's only referenced in velaro-shared

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
